// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"AnswerInput_deleteIcon__2S6MV"};